<wl-content-section
  [id]="sectionId"
  [theme]="theme"
  [hasContext]="!!context"
  [fluid]="true"
>
  @if (!!context) {
    <ng-container *ngTemplateOutlet="contentWrapper" />
  } @else {
    <div
      class="acquisition-commodity-offer-section"
      [ngStyle]="backgroundStyles"
    >
      <div class="container">
        <ng-container *ngTemplateOutlet="contentWrapper" />
      </div>
    </div>
  }
</wl-content-section>

<ng-template #contentWrapper>
  @if (viewModel$ | async; as vm) {
    @switch (content?.variant) {
      @case ('horizontal') {
        <wl-horizontal-commodity-offer
          [offers]="vm.offers"
          [content]="content"
          [showMemberGetMember]="vm.hasMemberGetMember"
          (selectOffer)="selectOffer($event)"
          (openMoreInfo)="openMoreInfo($event)"
          (viewTariffs)="viewTariffs($event)"
          (adjustCalculation)="adjustCalculation()"
          [supplyAddress]="vm.address"
          [consumptionValues]="vm.consumption"
          [hasSolarPanels]="vm.hasSolarPanels"
        />
      }
      @case ('vertical') {
        <wl-vertical-commodity-offer
          [offers]="vm.offers"
          [content]="content"
          [showMemberGetMember]="vm.hasMemberGetMember"
          (selectOffer)="selectOffer($event)"
          (openMoreInfo)="openMoreInfo($event)"
          (viewTariffs)="viewTariffs($event)"
          (adjustCalculation)="adjustCalculation()"
          [supplyAddress]="vm.address"
          [consumptionValues]="vm.consumption"
          [hasSolarPanels]="vm.hasSolarPanels"
        />
      }
      @case ('mixed') {
        <wl-mixed-commodity-offer
          [offers]="vm.offers"
          [content]="content"
          [showMemberGetMember]="vm.hasMemberGetMember"
          (selectOffer)="selectOffer($event)"
          (openMoreInfo)="openMoreInfo($event)"
          (viewTariffs)="viewTariffs($event)"
          (adjustCalculation)="adjustCalculation()"
          [supplyAddress]="vm.address"
          [consumptionValues]="vm.consumption"
          [hasSolarPanels]="vm.hasSolarPanels"
        />
      }
    }
  }

  @if (jssPlatformService.isEditorActive()) {
    <div class="card my-2">
      <div class="card-body">
        Plaats hier het component voor de calculate modal

        <sc-placeholder name="offer-calculate-modal" [rendering]="rendering" />
      </div>
    </div>
  }
</ng-template>
